import React from 'react'
import { Link } from "gatsby"
import styled from '@emotion/styled';
import { green01, pcHeaderH } from '../../_style';
import Filter from '../../components/organisms/filter';
import PageMain from '../../components/organisms/pageMain';
import imgMain from '../../assets/imgs/lineup/mondahmin-strongmint/img-main.png';
import DetailMain from '../../components/organisms/lineupDetail/detailMain';
import Taste from '../../components/atoms/lineupDetail/taste';
import ProductTitle from '../../components/atoms/lineupDetail/propductTitle';
import StimulationLevel from '../../components/atoms/stimulationLevel';
import LabelGroup from '../../components/molecules/labelGroup';
import DetailMainHead from '../../components/molecules/lineupDetail/detailMainHead';
import DetailMainBody from '../../components/molecules/lineupDetail/detailMainBody';
import CategoryGroup from '../../components/molecules/lineupDetail/categoryGroup';
import Br from '../../components/atoms/br';
import DetailTexts from '../../components/molecules/lineupDetail/detailTexts';
import data from '../../assets/data/products.json';
import BuyBtn from '../../components/atoms/buyBtn';
import Btn from '../../components/atoms/btn';
import BtnBlank from '../../components/atoms/btnBlank';
import DetailBtns from '../../components/molecules/lineupDetail/detailBtns';
import DetailBanners from '../../components/molecules/lineupDetail/detailBanners';
import Banner from '../../components/atoms/banner';
import DetailFeature from '../../components/organisms/lineupDetail/detailFeature';
import ContentWidth from '../../components/organisms/contentWidth';
import DetailFeatureBox from '../../components/molecules/lineupDetail/detailFeatureBox';
import BottomBtns from '../../components/molecules/lineupDetail/bottomBtns';
import SectionLineup from '../../components/organisms/sectionLineup';
import StoreBtnGroup from '../../components/molecules/storeBtnGroup';
import StoreBtn from '../../components/atoms/storeBtn';
import DetailFeatureItem from '../../components/molecules/lineupDetail/detailFeatureItem';
import { Helmet } from 'react-helmet';

const filteredData = data.filter((item, index) => {
  if(item.name === 'モンダミン ストロングミント') return true;
});

const isNoStoreBtns = (filteredData[0].amazonUrl === "") && (filteredData[0].lohacoUrl === "") && (filteredData[0].rakutenUrl === "");

const Container = styled.div`
`
const MondahminStrongmint = () => {
  return(
    <Container>
      <Helmet
        title="モンダミン ストロングミント | ラインナップ | モンダミン | アース製薬"
        meta={[
            { name: 'description', content: "ハードな刺激でお口すっきりリフレッシュ。油よごれもすっきり清潔に。モンダミン ストロングミントについてご紹介します。" },
            { name: 'keywords', content: "モンダミンストロングミント,洗口液,マウスウォッシュ,口臭,口臭ケア,オーラルケア,アース製薬" }
        ]}
      />
      <ContentWidth>
        <DetailMain imgPath={'lineup/mondahmin-strongmint/img-main.png'}>
          <DetailMainHead>
            <ProductTitle>{filteredData[0].name}</ProductTitle>
            <LabelGroup labels={filteredData[0].label}></LabelGroup>
            <StimulationLevel level={'6'}></StimulationLevel>
            <CategoryGroup categories={[<>口臭・汚れ<Br />ネバつき予防</>, <>アルコール<Br onlyPc />配合</>]}></CategoryGroup>
            <DetailTexts title={filteredData[0].description} captions={['＊1 TetPP：四リン酸6Na']}>
              ハードな刺激でお口すっきりリフレッシュ。油よごれもすっきり清潔に。イオンコーティング成分TetPP<sup>＊1</sup>配合。よごれの付着も予防。<Br />スキッとドライなストロングミントの香味。
            </DetailTexts>
          </DetailMainHead>
          <DetailMainBody>
            <dl>
              <dt>サイズ：</dt>
              <dd>100mL、380mL、1080mL</dd>
            </dl>
          </DetailMainBody>
          <DetailBtns isNoStoreBtns={isNoStoreBtns}>
            {!isNoStoreBtns &&
              <StoreBtnGroup>
                <StoreBtn store={'amazon'} href={filteredData[0].amazonUrl}></StoreBtn>
                <StoreBtn store={'rakuten'} href={filteredData[0].rakutenUrl}></StoreBtn>
                <StoreBtn store={'lohaco'} href={filteredData[0].lohacoUrl}></StoreBtn>
              </StoreBtnGroup>
            }
            <BtnBlank href={filteredData[0].productInfo}>製品情報サイトへ</BtnBlank>
          </DetailBtns>
        </DetailMain>
        <DetailFeature>
          <DetailFeatureItem>
            <DetailFeatureBox title={'すすぐだけ、よごれの除去と付着予防'} img={'lineup/feature/img-feature-01.jpg'} alt={'すすぐだけ、よごれの除去と付着予防'}>
              お口のトラブルの原因となるよごれ、ネバネバをしっかり洗浄します。<Br />よごれ洗浄成分PEG配合。油よごれもすっきり清潔に。
            </DetailFeatureBox>
            <DetailFeatureBox img={'lineup/feature/img-feature-02.jpg'} alt={'イオンコーティング成分'}>
              イオンコーティング成分TetPP<sup>＊1</sup>配合。よごれの付着を予防します。
            </DetailFeatureBox>
            <DetailFeatureBox title={<>爽快持続成分配合（香料中）</>}></DetailFeatureBox>
            <DetailFeatureBox title={<>キシリトール配合（矯味剤）</>}></DetailFeatureBox>
          </DetailFeatureItem>
        </DetailFeature>
        <BottomBtns productInfo={filteredData[0].productInfo}></BottomBtns>
      </ContentWidth>
      <SectionLineup></SectionLineup>
    </Container>
  );
}
export default MondahminStrongmint
